import React from "react";
import { useTranslation } from "react-i18next";

// MUI
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

const SidebarInfoBoxStaza = () => {
  const { t } = useTranslation();

  return (
    <Box m={2} p={0} pb={2}>
      {t("public.info_warning_1").split("|").map((txt: string, i: number) =>
        <Box p={0} width="100%" display="flex" flex="row" key={i}>
          <Typography variant="caption" color="#444" component="p">
            {txt}
          </Typography>
        </Box>
      )}
      <Box p={0} width="100%" display="flex" flex="row">
        <Typography variant="caption" color="#444" component="p">
          {t("public.info_warning_2")}
          <Link href="/sigurnosni-savjeti" underline="hover" target="_blank">
            {t("public.info_warning_link")}
          </Link>
        </Typography>
      </Box>
    </Box>
  )
}

export default SidebarInfoBoxStaza;